if (!customElements.get('slider-component')) {
  customElements.define(
    'slider-component',
    class SliderComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.dots = this.querySelectorAll('.slider-dot');

        if (!this.slider || !this.sliderItems.length) return;

        this.init();
      }

      init() {
        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        }
        if (this.dots.length > 0) {
          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.slideTo(index));
          });
        }

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          root: this.slider,
          rootMargin: '0px',
          threshold: 0.51, // A slide is "current" if >51% is visible
        });

        this.sliderItems.forEach((slide) => this.observer.observe(slide));
      }

      handleIntersection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const slideIndex = Array.from(this.sliderItems).indexOf(entry.target);
            this.updateDots(slideIndex);

            // Update disabled state for prev/next buttons if they exist
            if (this.prevButton && this.nextButton) {
              this.prevButton.disabled = slideIndex === 0;
              this.nextButton.disabled = slideIndex === this.sliderItems.length - 1;
            }
          }
        });
      }

      onButtonClick(event) {
        event.preventDefault();
        const currentSlideIndex = this.getCurrentSlideIndex();

        const slideToScroll =
          event.currentTarget.name === 'next'
            ? this.sliderItems[currentSlideIndex + 1]
            : this.sliderItems[currentSlideIndex - 1];

        if (slideToScroll) {
          slideToScroll.scrollIntoView({ behavior: 'smooth', inline: 'start' });
        }
      }

      getCurrentSlideIndex() {
        // Find the dot that is currently selected to determine the active slide index
        const activeDot = this.querySelector('.slider-dot[aria-selected="true"]');
        if (activeDot) {
          return Array.from(this.dots).indexOf(activeDot);
        }
        return 0; // Default to the first slide
      }

      slideTo(index) {
        if (this.sliderItems[index]) {
          this.sliderItems[index].scrollIntoView({
            behavior: 'smooth',
            inline: 'start',
            block: 'nearest',
          });
        }
      }

      updateDots(selectedIndex) {
        if (this.dots.length === 0) return;
        this.dots.forEach((dot, index) => {
          dot.toggleAttribute('aria-selected', index === selectedIndex);
        });
      }
    }
  );
}

